import { Dispatch } from 'redux';
import { AdvertType } from '@edikk-edikk/country-frontend';
import { getApiAdvertFavorite } from './api-advert-favorite';

const apiAdvertFavoriteRemoveAdvert = (
  apiAdvertFavorite: ReturnType<typeof getApiAdvertFavorite>,
  id: number,
  dispatch: Dispatch,
): void => {
  // @ts-ignore
  dispatch(apiAdvertFavorite.util.updateQueryData(
    'init',
    undefined,
    (draft) => {
      draft.adverts.items = draft.adverts.items.filter((advert: AdvertType) => advert.id !== id);
    },
  ));
};

export { apiAdvertFavoriteRemoveAdvert };
